module.exports = __webpack_public_path__ + "static/media/lucidagrande-bold-webfont.74271549.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/lucidagrande-bold-webfont.otf
// module id = 537
// module chunks = 0